import React from 'react';
import { useTranslation } from 'react-i18next';
import Carousel from 'react-elastic-carousel';
import { Flex, Text } from '@tonic-ui/react';
import Tiles from './tiles';
import NavigationButtons from './navigation-buttons';

// tile background images
import bgImgResources1 from '../../../assets/landing/img/resources1.png';
import bgImgResources2 from '../../../assets/landing/img/resources2.png';
import bgImgResources3 from '../../../assets/landing/img/resources3.png';

const TileCarousel = (): JSX.Element => {
  const { t } = useTranslation();
  const tiles = [
    {
      id: '1',
      image: bgImgResources1,
      heading: t('publicLandingPage.tileCarouselContent.tile1.heading'),
      description: t('publicLandingPage.tileCarouselContent.tile1.description'),
      linkText: t('publicLandingPage.tileCarouselContent.tile1.linkTxt'),
      linkUrl: t('publicLandingPage.tileCarouselContent.tile1.linkUrl'),
    },
    {
      id: '2',
      image: bgImgResources2,
      heading: t('publicLandingPage.tileCarouselContent.tile2.heading'),
      description: t('publicLandingPage.tileCarouselContent.tile2.description'),
      linkText: t('publicLandingPage.tileCarouselContent.tile2.linkTxt'),
      linkUrl: t('publicLandingPage.tileCarouselContent.tile2.linkUrl'),
    },
    {
      id: '3',
      image: bgImgResources3,
      heading: t('publicLandingPage.tileCarouselContent.tile3.heading'),
      description: t('publicLandingPage.tileCarouselContent.tile3.description'),
      linkText: t('publicLandingPage.tileCarouselContent.tile3.linkTxt'),
      linkUrl: t('publicLandingPage.tileCarouselContent.tile3.linkUrl'),
    },
    {
      id: '4',
      image: bgImgResources2,
      heading: t('publicLandingPage.tileCarouselContent.tile4.heading'),
      description: t('publicLandingPage.tileCarouselContent.tile4.description'),
      linkText: t('publicLandingPage.tileCarouselContent.tile4.linkTxt'),
      linkUrl: t('publicLandingPage.tileCarouselContent.tile4.linkUrl'),
    },
    {
      id: '5',
      image: bgImgResources3,
      heading: t('publicLandingPage.tileCarouselContent.tile5.heading'),
      description: t('publicLandingPage.tileCarouselContent.tile5.description'),
      linkText: t('publicLandingPage.tileCarouselContent.tile5.linkTxt'),
      linkUrl: t('publicLandingPage.tileCarouselContent.tile5.linkUrl'),
    },
    {
      id: '6',
      image: bgImgResources2,
      heading: t('publicLandingPage.tileCarouselContent.tile6.heading'),
      description: t('publicLandingPage.tileCarouselContent.tile6.description'),
      linkText: t('publicLandingPage.tileCarouselContent.tile6.linkTxt'),
      linkUrl: t('publicLandingPage.tileCarouselContent.tile6.linkUrl'),
    },
  ];
  return (
    <Flex flexDirection="column" minWidth="900px" paddingBottom="7x">
      <Text
        mt="20px"
        mb="48px"
        fontWeight="light"
        fontSize="2.5rem"
        lineHeight="4rem"
        alignSelf="center"
        color="black:secondary"
      >
        {t('publicLandingPage.tileCarouselContent.title')}
      </Text>

      <Carousel
        itemsToScroll={1}
        isRTL={false}
        renderPagination={(props) => <NavigationButtons {...props} />}
        showArrows={false}
        breakPoints={[
          { width: 900, itemsToShow: 2.5 },
          { width: 1078, itemsToShow: 3.1 },
          { width: 1256, itemsToShow: 3.5 },
        ]}
      >
        {tiles.map((tile) => (
          <Tiles {...tile} key={`${tile.id}`} width={351} height={332} />
        ))}
      </Carousel>
    </Flex>
  );
};

TileCarousel.displayName = 'TileCarousel';

export default TileCarousel;
